import { db } from "@/firebase/init.js";
import {
  // General
  collection,
  doc,
  // Get All
  getDocs,
  query,
  // Get by Sort
  orderBy,
  // Add one
  setDoc,
  // Add many at once
  writeBatch,
  // Delete one
  deleteDoc,
  // Pagination -- Search -- Sort
  limit,
   startAfter,
  where,
 } from "firebase/firestore";

const codesModule = {
  namespaced: true,
  state: {
    codesList: [],
    searchResult: [],
    isLoading: true,
    isFirstLoad: true,
    // Pagination
    loadingMore: false,
    showLoadingButton: true,
    lastVisible: "",
    orderBy: "created_date",
    // Filter Pagination
    filterLastVisible: "",
    haveMoreFilterData: false,
    loadMore: false,
  },
  getters: {
    getCodes: (state) => state.codesList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
    loadMore: (state) => state.loadMore,
    // Pagination
    isLoadingMore: (state) => state.loadingMore,
    isShowLoadingButton: (state) => state.showLoadingButton,
    // Search
    getSearchResult: (state) => state.searchResult,
    // Filter
    isHaveMoreFilterData: (state) => state.haveMoreFilterData,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },
    // Get All Codes

    // Add Code
    addCode: (state, payload) => {
      if (state.codesList.length > 0) state.codesList.unshift(payload);
      else state.codesList = [payload];
    },
    // Delete Code
    deleteCode: (state, payload) => {
      let filtered = state.codesList.filter(function (value) {
        return value.code_id != payload;
      });
      state.codesList = filtered;
    },

    // Pagination and Sort and Search
    // Get Next
    setData: (state, payload) => {
      state.codesList = payload;
    },
    setNextData: (state, payload) => {
      state.codesList.push(...payload);
    },
    setShowLoadingButton: (state, payload) => {
      state.showLoadingButton = payload;
    },
    setLoadingMore: (state, payload) => {
      state.loadingMore = payload;
    },
    setLoadMore: (state, payload) => {
      state.loadMore = payload;
    },
    // Get Search Result
    setSearchResult: (state, payload) => {
      state.searchResult = payload;
    },
    setNextSearchResult: (state, payload) => {
      state.searchResult.push(...payload);
    },
    setLastVisible: (state, payload) => {
      state.lastVisible = payload;
    },
    setHaveMoreFilterData: (state, payload) => {
      state.haveMoreFilterData = payload;
    },
    // Last Data
    setFilterLastVisible: (state, payload) => {
      state.filterLastVisible = payload;
    },

    setOrderBy: (state, payload) => {
      state.orderBy = payload;
    },
  },
  actions: {
    //---- Pagination
    async getFirstData({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const data = await getDocs(
        query(
          collection(db, "Codes"),
          orderBy(this.state.codesModule.orderBy, "desc"),
          limit(10)
        )
      );

      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);

      let dataArray = [];

      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ code_id: doc.id, ...doc.data() });
        });
      } else {
        dataArray = false;
      }

      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }

      commit("setData", dataArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      // commit("setLoadMore", size > 10 ? true : false);
    },

    async getNextData({ commit }) {
      commit("setLoadingMore", true);
      const data = await getDocs(
        query(
          collection(db, "Codes"),
          orderBy(this.state.codesModule.orderBy, "desc"),
          limit(10),
          startAfter(this.state.codesModule.lastVisible)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      console.log(data);
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ code_id: doc.id, ...doc.data() });
        });
      }
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setNextData", dataArray);
      commit("setLoadingMore", false);
    },

    changeSorting({ commit }, payload) {
      commit("setOrderBy", payload);
    },
    // ----- Search
    async searchData({ commit }, payload) {
        commit("setFirstLoad", false);
 
      const data = await getDocs(
        query(
          collection(db, "Codes"),
           orderBy('serial'),
           where("serial", ">=", payload),
          limit(10)
        )
      );
      let dataArray = [];
      data.forEach((doc) => {
        dataArray.push({ code_id: doc.id, ...doc.data() });
      });
      commit("setSearchResult", dataArray);
    },
    // ----- Filter

    async nextFilterData({ commit }, payload) {
      let dataArray = [];
      if (payload) {
        const data = await getDocs(
          query(
            collection(db, "Codes"),
            where("date_of_usage", "!=", null),
            limit(10),
            startAfter(this.state.codesModule.filterLastVisible)
          )
        );
        const lastVisible = data.docs[data.docs.length - 1] || null;
        commit("setFilterLastVisible", lastVisible);

        if (!data.empty) {
          data.forEach((doc) => {
            dataArray.push({ code_id: doc.id, ...doc.data() });
          });
        }
        if (data.size != 10) {
          commit("setHaveMoreFilterData", false);
        } else {
          commit("setHaveMoreFilterData", true);
        }
      } else {
        const data = await getDocs(
          query(
            collection(db, "Codes"),
            where("date_of_usage", "==", null),
            limit(10),
            startAfter(this.state.codesModule.filterLastVisible)
          )
        );
        const lastVisible = data.docs[data.docs.length - 1] || null;
        commit("setFilterLastVisible", lastVisible);

        if (!data.empty) {
          data.forEach((doc) => {
            dataArray.push({ code_id: doc.id, ...doc.data() });
          });
        }
        if (data.size != 10) {
          commit("setHaveMoreFilterData", false);
        } else {
          commit("setHaveMoreFilterData", true);
        }
      }

      commit("setNextSearchResult", dataArray);
    },

    async filterData({ commit }, payload) {
      commit("setLoading", true);
      let dataArray = [];
      if (payload) {
        const data = await getDocs(
          query(
            collection(db, "Codes"),
            where("date_of_usage", "!=", null),
            limit(10)
          )
        );
        const lastVisible = data.docs[data.docs.length - 1] || null;
        commit("setFilterLastVisible", lastVisible);
        data.forEach((doc) => {
          dataArray.push({ code_id: doc.id, ...doc.data() });
        });
        if (data.size != 10) {
          commit("setHaveMoreFilterData", false);
        } else {
          commit("setHaveMoreFilterData", true);
        }
      } else {
        const data = await getDocs(
          query(
            collection(db, "Codes"),
            where("date_of_usage", "==", null),
            limit(10)
          )
        );
        const lastVisible = data.docs[data.docs.length - 1] || null;
        commit("setFilterLastVisible", lastVisible);
        data.forEach((doc) => {
          dataArray.push({ code_id: doc.id, ...doc.data() });
        });
        if (data.size != 10) {
          commit("setHaveMoreFilterData", false);
        } else {
          commit("setHaveMoreFilterData", true);
        }
      }
      commit("setSearchResult", dataArray);
      commit("setLoading", false);
    },
    //
    //
    //
    //
    //
    //
    //
    //
    // Add Code
    async addCode({ commit }, payload) {
      const documentReference = doc(collection(db, "Codes"));
      const code = {
        ...payload,
        created_date: new Date(),
        code_id: documentReference.id,
        code: documentReference.id,
        date_of_usage: null,
      };
      await setDoc(documentReference, code);
      commit("addCode", code);
    },

    // Add Multi Codes
    // Returns the codes it created so the caller can print exactly this batch.
    // Every code in one call shares a `batch_id`, which makes a batch
    // re-printable later.
    async addCodes({ commit }, payload) {
      const batch = writeBatch(db);
      const batchId = doc(collection(db, "Codes")).id;
      const createdDate = new Date();
      const createdCodes = [];

      for (let i = 0; i < payload.length; i++) {
        const documentReference = doc(collection(db, "Codes"));
        const code = {
          ...payload[i],
          created_date: createdDate,
          code_id: documentReference.id,
          code: documentReference.id,
          batch_id: batchId,
          date_of_usage: null,
        };
        batch.set(documentReference, code);
        createdCodes.push(code);
      }

      await batch.commit();
      createdCodes.forEach((code) => commit("addCode", code));

      return createdCodes;
    },

    // Delete Code
    async deleteCode({ commit }, payload) {
      deleteDoc(doc(collection(db, "Codes"), payload));
      commit("deleteCode", payload);
    },

    async deleteCodes({ commit }, payload) {
      for (let i = 0; i < payload.length; i++) {
        console.log(payload[i]);
        deleteDoc(doc(collection(db, "Codes"), payload[i].code_id));
        commit("deleteCode", payload[i].code_id);
      }
    },
  },
};

export default codesModule;
